module.exports = __webpack_public_path__ + "img/live_collaboration.cb40d9e5.png";